// Ignition Memory App - Achievement System
// Clinical, professional achievement tracking for cognitive training

window.IgnitionAchievements = {
  // Configuration
  apiEndpoint: 'https://quiz.igniton.com/api/achievements',
  currentCustomer: null,
  achievements: [],
  stats: null,
  
  // SVG Icons for achievements (clean, clinical design)
  icons: {
    // Speed achievements
    speed_demon: '<svg viewBox="0 0 24 24"><path d="M13.13 2.05C13.13 2.05 10.3 2.85 9.3 6.5C8.3 10.15 9.21 11.72 9.21 11.72S7.5 13.89 7.5 17.39C7.5 20.89 9.62 21.97 9.62 21.97S11.41 20.14 12.06 17.28C12.71 14.42 12.17 12.68 12.17 12.68S14.68 10.36 14.68 7.69C14.68 5 13.13 2.05 13.13 2.05M20.5 12.67C20.5 17.33 16.87 21.13 12.29 21.47C11.76 20.74 11.5 19.73 11.5 18.63C11.5 17.94 11.61 17.24 11.77 16.62C12.38 17 13.22 17.41 14.5 17.41C17.94 17.41 19.15 15.59 19.15 15.59S18.34 15.09 17.22 15.09C16.65 15.09 16.11 15.22 15.66 15.42C15.78 14.76 15.78 14.15 15.66 13.74C15.95 13.85 16.27 13.92 16.63 13.92C18.5 13.92 19.44 12.8 19.44 12.8S18.46 12.28 17 12.28C16.26 12.28 15.63 12.5 15.28 12.68C14.87 11.69 14 10.89 13 10.4C13.03 10.25 13.05 10.11 13.05 9.97C13.05 8.7 12.46 7.44 11.71 6.5C16.36 6.67 20.5 10.25 20.5 12.67Z"/></svg>',
    perfect_score: '<svg viewBox="0 0 24 24"><path d="M12 2L14.09 8.26L21 9.27L16.5 13.63L17.82 20.47L12 17.27L6.18 20.47L7.5 13.63L3 9.27L9.91 8.26L12 2M12 6.2L10.6 10.2L6.4 10.8L9.2 13.4L8.6 17.6L12 15.5L15.4 17.6L14.8 13.4L17.6 10.8L13.4 10.2L12 6.2Z"/></svg>',
    
    // Dedication achievements
    first_test: '<svg viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 4C16.41 4 20 7.59 20 12S16.41 20 12 20 4 16.41 4 12 7.59 4 12 4M10 9V15H14V9H10Z"/></svg>',
    daily_grinder: '<svg viewBox="0 0 24 24"><path d="M9 11H7V13H9V11M13 11H11V13H13V11M17 11H15V13H17V11M19 4H18V2H16V4H8V2H6V4H5A2 2 0 0 0 3 6V20A2 2 0 0 0 5 22H19A2 2 0 0 0 21 20V6A2 2 0 0 0 19 4M19 20H5V9H19V20Z"/></svg>',
    committed: '<svg viewBox="0 0 24 24"><path d="M15 14C16.11 14 17 13.11 17 12C17 10.89 16.11 10 15 10C13.89 10 13 10.89 13 12C13 13.11 13.89 14 15 14M15 2C10.04 2 6 6.04 6 11C6 15.96 10.04 20 15 20C19.96 20 24 15.96 24 11C24 6.04 19.96 2 15 2M15 18C11.14 18 8 14.86 8 11C8 7.14 11.14 4 15 4C18.86 4 22 7.14 22 11C22 14.86 18.86 18 15 18M3 11C3 10.45 3.1 9.92 3.24 9.41L1.34 8.84C1.12 9.53 1 10.26 1 11C1 11.74 1.12 12.47 1.34 13.16L3.24 12.59C3.1 12.08 3 11.55 3 11Z"/></svg>',
    dedicated: '<svg viewBox="0 0 24 24"><path d="M12 2L15.09 3.26L18.27 1.44L18.88 4.85L22.11 6.11L20.85 9.29L22.67 12.38L19.59 13.64L18.33 16.82L15.15 15.56L12.06 17.38L8.97 15.56L5.79 16.82L4.53 13.64L1.45 12.38L3.27 9.29L2.01 6.11L5.24 4.85L5.85 1.44L9.03 3.26L12 2Z"/></svg>',
    century_club: '<svg viewBox="0 0 24 24"><path d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"/></svg>',
    
    // Test type achievements
    explorer: '<svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20M12 6C8.69 6 6 8.69 6 12S8.69 18 12 18 18 15.31 18 12 15.31 6 12 6M12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16Z"/></svg>',
    specialist_speed: '<svg viewBox="0 0 24 24"><rect x="8" y="8" width="8" height="8" stroke="currentColor" fill="none" stroke-width="2"/></svg>',
    specialist_memory: '<svg viewBox="0 0 24 24"><path d="M17 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V5C19 3.9 18.1 3 17 3M17 19H7V5H17V19M12 7C13.1 7 14 7.9 14 9S13.1 11 12 11 10 10.1 10 9 10.9 7 12 7M12 15C13.1 15 14 15.9 14 17S13.1 19 12 19 10 18.1 10 17 10.9 15 12 15Z"/></svg>',
    
    // Special achievements
    early_bird: '<svg viewBox="0 0 24 24"><path d="M3 12H7C7 9.24 9.24 7 12 7S17 9.24 17 12H21C21 6.48 16.52 2 11 2C5.48 2 1 6.48 1 12C1 13.19 1.19 14.34 1.52 15.41L3 12M12 2C12 2 12 7 16 7C16 7 12 7 12 12C12 12 12 7 8 7C8 7 12 7 12 2M9 12C9 13.66 10.34 15 12 15S15 13.66 15 12 13.66 9 12 9 9 10.34 9 12M12 20L15 17H9L12 20Z"/></svg>',
    night_owl: '<svg viewBox="0 0 24 24"><path d="M12 2C9.5 2 7.3 3 5.6 4.6L7.4 6.4C8.6 5.2 10.2 4.5 12 4.5C15 4.5 17.5 6.6 18.4 9.4L21 8.5C19.6 4.9 16.2 2 12 2M12 7C9.2 7 7 9.2 7 12S9.2 17 12 17 17 14.8 17 12 14.8 7 12 7M10 12.5L11.5 11L13 12.5L11.5 14L10 12.5M3 12C3 13.8 3.6 15.5 4.6 16.9L6.4 15.1C5.9 14.3 5.5 13.2 5.5 12C5.5 10.8 5.9 9.7 6.4 8.9L4.6 7.1C3.6 8.5 3 10.2 3 12M12 19.5C10.2 19.5 8.6 18.8 7.4 17.6L5.6 19.4C7.3 21 9.5 22 12 22C16.2 22 19.6 19.1 21 15.5L18.4 14.6C17.5 17.4 15 19.5 12 19.5Z"/></svg>',
    memory_master: '<svg viewBox="0 0 24 24"><path d="M21.33 12.91C21.42 14.46 20.71 15.95 19.44 16.86L20.21 18.35C20.44 18.8 20.47 19.33 20.27 19.8C20.08 20.27 19.69 20.64 19.21 20.8L18.42 21.05C18.25 21.11 18.06 21.14 17.88 21.14C17.37 21.14 16.89 20.91 16.56 20.5L14.44 18C13.55 17.85 12.71 17.47 12 16.9C11.5 17.05 11 17.13 10.5 17.13C9.62 17.13 8.74 16.86 8 16.34C7.47 16.5 6.93 16.57 6.38 16.56C5.59 16.57 4.81 16.41 4.08 16.11C2.65 15.47 1.7 14.07 1.65 12.5C1.57 11.78 1.69 11.05 2 10.39C1.71 9.64 1.68 8.82 1.93 8.06C2.3 7.11 3 6.32 3.87 5.82C4.45 4.13 6.08 2.86 7.87 2.85C8.09 2.85 8.31 2.88 8.53 2.94C9.04 1.77 10.07 .89 11.34 .59C13.29 .04 15.25 1.26 15.66 3.23L15.84 4.14L16.74 4.38C17.05 4.47 17.36 4.59 17.64 4.76L18.22 5.08C19.04 4.8 19.93 4.76 20.76 5C22.25 5.45 23.26 6.91 23.05 8.44C23 8.55 23 8.67 23 8.78L23 8.91C23.05 9.3 22.96 9.68 22.78 10L22.5 10.37C22.81 11.04 22.97 11.78 22.95 12.5C22.91 13.26 22.68 14 22.28 14.63C22 15.06 21.64 15.43 21.23 15.73C21.31 16.04 21.35 16.36 21.35 16.67C21.35 17.03 21.28 17.39 21.16 17.73C20.83 18.69 19.93 19.37 18.89 19.41L19.27 20.26C19.41 20.56 19.4 20.9 19.26 21.19C19.12 21.5 18.84 21.72 18.5 21.81L17.74 22.04C17.32 22.18 16.85 22.08 16.5 21.8C16.16 21.5 16 21.06 16.04 20.63L16.09 20.2C15.46 20 14.83 19.66 14.28 19.19L13.29 18.05C12.59 17.85 11.92 17.5 11.34 17C11.03 17.05 10.73 17.08 10.42 17.08C9.64 17.08 8.86 16.85 8.18 16.41C7.73 16.5 7.26 16.57 6.81 16.57C6.05 16.58 5.31 16.42 4.61 16.12C3.39 15.55 2.56 14.31 2.53 12.91C2.5 12.33 2.6 11.76 2.85 11.23C2.61 10.6 2.55 9.91 2.71 9.24C2.96 8.35 3.5 7.59 4.22 7.08C4.74 5.65 6.13 4.59 7.69 4.57C7.88 4.57 8.07 4.59 8.26 4.64C8.72 3.64 9.62 2.86 10.72 2.6C12.46 2.13 14.2 3.21 14.55 4.95L14.64 5.37L15.09 5.5C15.38 5.59 15.65 5.71 15.9 5.87L16.13 6L16.47 5.91C17.17 5.67 17.92 5.64 18.64 5.84C19.86 6.18 20.69 7.31 20.54 8.56C20.53 8.65 20.53 8.75 20.53 8.84L20.53 8.96C20.57 9.28 20.5 9.61 20.36 9.89L20.16 10.21C20.39 10.79 20.53 11.42 20.53 12.08C20.5 12.77 20.29 13.42 19.93 14C19.67 14.38 19.33 14.7 18.93 14.93C19 15.17 19.03 15.42 19.03 15.67C19.03 15.97 19 16.27 18.86 16.56C18.56 17.35 17.8 17.9 16.91 17.93L17.19 18.53C17.3 18.78 17.29 19.06 17.17 19.29C17.05 19.53 16.84 19.7 16.58 19.77L15.86 20C15.44 20.13 15 20.03 14.66 19.75C14.32 19.46 14.15 19.03 14.19 18.6L14.24 18.17C13.66 18 13.12 17.7 12.62 17.3L11.7 16.24C11.07 16.06 10.47 15.75 9.94 15.33C9.66 15.38 9.38 15.4 9.1 15.4C8.4 15.4 7.7 15.19 7.08 14.79C6.67 14.88 6.25 14.94 5.83 14.94C5.13 14.94 4.45 14.8 3.81 14.5C2.72 14 1.97 12.9 1.94 11.66C1.91 11.13 2 10.6 2.21 10.12C2 9.54 1.96 8.93 2.09 8.34C2.31 7.53 2.79 6.84 3.43 6.38C3.91 5.07 5.18 4.1 6.62 4.08C6.79 4.08 6.97 4.1 7.14 4.14C7.55 3.21 8.37 2.5 9.37 2.26C11 1.82 12.63 2.84 12.96 4.5L13.15 5.53L14 5.76C14.29 5.85 14.56 5.96 14.82 6.11L15.35 6.41C16.13 6.15 16.97 6.11 17.76 6.33C19.15 6.75 20.09 8.1 19.9 9.53C19.89 9.62 19.89 9.71 19.89 9.8L19.89 9.92C19.93 10.29 19.84 10.65 19.67 10.96L19.41 11.44C19.7 12.08 19.85 12.78 19.84 13.5C19.8 14.22 19.57 14.91 19.18 15.5C18.91 15.91 18.55 16.25 18.12 16.5C18.19 16.77 18.23 17.05 18.23 17.33Z"/></svg>',
    
    // Challenge achievements
    getting_better: '<svg viewBox="0 0 24 24"><path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"/></svg>',
    comeback_kid: '<svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M12 20C7.58 20 4 16.42 4 12S7.58 4 12 4 20 7.58 20 12 16.42 20 12 20M16.17 14.76L12 10.59L7.83 14.76L6.41 13.34L12 7.75L17.59 13.34L16.17 14.76Z"/></svg>',
    
    // Default lock icon
    locked: '<svg viewBox="0 0 24 24"><path d="M18 8H17V6C17 3.24 14.76 1 12 1S7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M12 17C10.9 17 10 16.1 10 15S10.9 13 12 13 14 13.9 14 15 13.1 17 12 17M15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9S15.1 4.29 15.1 6V8Z"/></svg>'
  },
  
  // Initialize achievement system
  init(customerId) {
    if (!customerId) return;
    
    this.currentCustomer = customerId;
    this.loadAchievements();
    this.setupEventListeners();
  },
  
  // Load achievements from API
  async loadAchievements() {
    try {
      const response = await fetch(`${this.apiEndpoint}?customer_id=${this.currentCustomer}`);
      const data = await response.json();
      
      if (data.error) {
        console.error('Achievement API error:', data.error);
        return;
      }
      
      this.achievements = data.achievements;
      this.stats = data.stats;
      this.progress = data.progress;
      
      this.renderAchievements();
      this.renderProgress();
      
    } catch (error) {
      console.error('Failed to load achievements:', error);
    }
  },
  
  // Render achievement grid
  renderAchievements() {
    const container = document.getElementById('achievement-container');
    if (!container) return;
    
    // Group achievements by category
    const categories = {
      speed: { name: 'Speed & Accuracy', achievements: [] },
      dedication: { name: 'Dedication', achievements: [] },
      challenge: { name: 'Challenges', achievements: [] },
      special: { name: 'Special', achievements: [] }
    };
    
    this.achievements.forEach(achievement => {
      const category = categories[achievement.badge_category] || categories.special;
      category.achievements.push(achievement);
    });
    
    let html = '<div class="achievement-system">';
    
    // Stats section
    html += `
      <div class="progress-section">
        <div class="progress-header">
          <div>
            <h3>Your Achievement Progress</h3>
            <p>Earn badges by completing memory tests and improving your cognitive performance.</p>
          </div>
          <div class="progress-stats">
            <div class="stat-item">
              <span class="stat-value">${this.stats.total_badges || 0}</span>
              <span class="stat-label">Badges Earned</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">${this.stats.total_points || 0}</span>
              <span class="stat-label">Total Points</span>
            </div>
            ${this.stats.global_rank ? `
              <div class="stat-item">
                <span class="stat-value">#${this.stats.global_rank}</span>
                <span class="stat-label">Global Rank</span>
              </div>
            ` : ''}
          </div>
        </div>
      </div>
    `;
    
    // Achievement categories
    Object.entries(categories).forEach(([key, category]) => {
      if (category.achievements.length === 0) return;
      
      html += `
        <div class="achievement-category">
          <h3>${category.name}</h3>
          <div class="achievement-grid">
      `;
      
      category.achievements.forEach(achievement => {
        const isEarned = achievement.earned;
        const icon = this.icons[achievement.badge_code] || this.icons.locked;
        
        html += `
          <div class="achievement-card ${isEarned ? 'earned' : 'locked'}" 
               data-badge="${achievement.badge_code}"
               data-rarity="${achievement.rarity}">
            <div class="achievement-header">
              <div class="badge-icon ${achievement.rarity} ${!isEarned ? 'locked' : ''}">
                ${icon}
              </div>
              <div class="achievement-info">
                <h4>${achievement.badge_name}</h4>
                <p class="description">${achievement.badge_description}</p>
              </div>
            </div>
            <div class="achievement-meta">
              <span class="points-badge">${achievement.points} pts</span>
              ${isEarned && achievement.unlocked_at ? `
                <span class="earned-date">Earned ${this.formatDate(achievement.unlocked_at)}</span>
              ` : ''}
            </div>
          </div>
        `;
      });
      
      html += '</div></div>';
    });
    
    html += '</div>';
    container.innerHTML = html;
  },
  
  // Render progress to next achievement
  renderProgress() {
    const container = document.getElementById('progress-container');
    if (!container || !this.progress) return;
    
    let progressHtml = '';
    
    if (this.progress.next_badge_code) {
      const nextAchievement = this.achievements.find(a => a.badge_code === this.progress.next_badge_code);
      if (nextAchievement) {
        const percentage = Math.max(0, 100 - (this.progress.actions_remaining / (this.progress.action_type === 'test types' ? 6 : 25) * 100));
        
        progressHtml = `
          <div class="next-achievement-progress">
            <h4>Next Achievement</h4>
            <div class="progress-item">
              <div class="progress-info">
                <span class="achievement-name">${nextAchievement.badge_name}</span>
                <span class="progress-text">${this.progress.actions_remaining} ${this.progress.action_type} remaining</span>
              </div>
              <div class="progress-bar-container">
                <div class="progress-bar-fill" style="width: ${percentage}%"></div>
              </div>
            </div>
          </div>
        `;
      }
    }
    
    container.innerHTML = progressHtml;
  },
  
  // Check for new achievements after test completion
  async checkNewAchievements(testType, testResult) {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer_id: this.currentCustomer,
          test_type: testType,
          test_result: testResult
        })
      });
      
      const data = await response.json();
      
      if (data.newAchievements && data.newAchievements.length > 0) {
        data.newAchievements.forEach(badgeCode => {
          const achievement = this.achievements.find(a => a.badge_code === badgeCode);
          if (achievement) {
            this.showAchievementNotification(achievement);
          }
        });
        
        // Reload achievements to get updated data
        setTimeout(() => this.loadAchievements(), 1000);
      }
      
    } catch (error) {
      console.error('Failed to check achievements:', error);
    }
  },
  
  // Show achievement notification
  showAchievementNotification(achievement) {
    const notification = document.createElement('div');
    notification.className = 'achievement-notification';
    notification.innerHTML = `
      <div class="achievement-notification-header">
        <div class="notification-icon">
          <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
            <path d="M12 2L14.39 8.26L21 9.27L16.5 13.63L17.82 20.47L12 17.27L6.18 20.47L7.5 13.63L3 9.27L9.91 8.26L12 2Z"/>
          </svg>
        </div>
        <div class="notification-content">
          <h4>Achievement Unlocked!</h4>
          <p>${achievement.badge_name} - ${achievement.points} points</p>
        </div>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    // Trigger animation
    setTimeout(() => notification.classList.add('show'), 100);
    
    // Remove after 5 seconds
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 5000);
  },
  
  // Setup event listeners
  setupEventListeners() {
    // Listen for test completion events
    document.addEventListener('memory-test-completed', (e) => {
      this.checkNewAchievements(e.detail.testType, e.detail.testResult);
    });
  },
  
  // Utility: Format date
  formatDate(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 1) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    
    return date.toLocaleDateString();
  }
};